import destinationPage from './destinationPage.base64'
import cardboardEmptyState from './cardboardEmptyState.base64'

export default {
  destinationPage,
  cardboardEmptyState
}